class WithRetry {
    constructor(action = () => {}, options = {}) {
        const {retries = 1} = options || {};
        this.action = action;
        this.retries = retries >= 1 ? retries : 1;
        this.count = 0;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        this.perform();
    }

    perform() {
        return this.action()
            .then((data) => this.resolve(data))
            .catch((error) => {
                this.count++;
                return this.count >= this.retries ? this.reject(error) : this.perform().catch(() => {});
            });
    }

    getPromise() {
        return this.promise;
    }
}

module.exports = (action, retries) => new WithRetry(action, retries).getPromise();
